export const pickDataAueProps = (props) => {
    const result = {};
    for (const key in props) {
        if (key.startsWith('data-aue')) {
            result[key] = props[key];
        }
    }
    return result;
};
//# sourceMappingURL=pick-data-aue-props.js.map